'use strict';

angular.module('domain.userdefobj', ['ngRoute', 'upResources', 'security.authorization', 'services.customer']);
